import {
  triggerPayPalOnboardingCanvas,
  triggerStripeOnboardingCanvas,
} from '../payments-data/payments-data.actions';
import { openI2gMoneyOnboarding } from '../settings-data/settings-data.actions';
import { TrackingScreenNamesEnum } from '../tracking/tracking.data';
import { IDeepLinkProperties } from './deep-link-properties.interface';
import { ScreenNamesEnum } from './screen-names.enum';

export const SCREEN_NAMES_TO_ACTION: {
  [screenName: string]: (deepLinkProperties: IDeepLinkProperties) => any;
} = {
  [ScreenNamesEnum.card_payments_onboarding]: (): any => {
    return triggerStripeOnboardingCanvas(true);
  },
  [ScreenNamesEnum.paypal_onboarding]: (): any => {
    return triggerPayPalOnboardingCanvas();
  },
  // This is to trigger I2G Money onboarding from FTU task list item
  [ScreenNamesEnum.settings]: (
    deepLinkProperties: IDeepLinkProperties
  ): any => {
    /**
     * The deep link for I2g Money onboarding
     * looks like this: i2g://navigate/settings?c=unit_ach_bank_transfers
     * there we check for presence of 'c' and its value in params
     */
    if (
      deepLinkProperties.params &&
      'c' in deepLinkProperties.params &&
      deepLinkProperties.params.c === 'unit_ach_bank_transfers'
    ) {
      return openI2gMoneyOnboarding(TrackingScreenNamesEnum.home);
    }
    return null;
  },
};
